import {i18n} from '@yourcoach/i18n';

export const labelCoaches = () => i18n.t('web-app:MainMenu.Coaches');

export const labelTutorials = () => i18n.t('web-app:MainMenu.Tutorials');

export const labelContent = () => i18n.t('shared:content');

export const labelMyCoaches = (count = 2) =>
  i18n.t('web-app:MainMenu.MyCoaches', {
    count,
  });

export const labelDashboard = () => i18n.t('web-app:MainMenu.Dashboard');

export const labelToDos = () => i18n.t('web-app:MainMenu.To-dos');

export const labelChats = () => i18n.t('web-app:MainMenu.Chats');

export const labelGoals = () => i18n.t('web-app:MainMenu.Goals');

export const labelProfile = () => i18n.t('web-app:MainMenu.Profile');
